import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title mb-0" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4"
}
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "pagination-mini" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled"]

import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import apiService from '@/services/apiService';
// import zeroConfiguration from '@/components/commen/table/zeroConfiguration.vue';
import CommonTable2 from '@/components/commen/table/CommonTable2.vue';
import { usePermissions } from '@/composables/usePermissions';

const pageTitle = "Workspace Modules";

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'workspacemodulesList',
  setup(__props) {

const { canCreate } = usePermissions();

const router = useRouter();

// Constants
const activeTab = ref<'default' | 'lookup'>('default');
const isLoading = ref(false);
const error = ref<string | null>(null);
const modules = ref<any[]>([]);

// --- Pagination State ---
const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});

// Computed properties
const currentTabTitle = computed(() => 
  activeTab.value === 'default' ? 'Default Modules' : 'By Users Modules'
);

// Table configuration for zeroConfiguration component
const tableConfig = computed(() => ({
  data: processedModules.value,
  columns: [
    { name: "Icon", field: "icon", sortable: false },
    { name: "Title", field: "title", sortable: true },
    { name: "Type", field: "module_type", sortable: false },
  ],
  actions: activeTab.value === 'default' ? [true] : [false], // Only show actions for default tab
  loading: isLoading.value,
  showCategoryFilter: false,
  showStatusFilter: false,
  table_width: "max-content",
}));

const changeRows = async () => {
  tablePagination.value.current_page = 1;
  await fetchModules(1, tablePagination.value.per_page);
};

const handlePageChange = async (page: number) => {
  if (page < 1 || page === tablePagination.value.current_page) return;
  if (page > tablePagination.value.total_pages) return;

  await fetchModules(page, tablePagination.value.per_page);
};

// Process modules data to ensure icons are properly formatted for zeroConfiguration
const processedModules = computed(() => 
  modules.value.map(module => ({
    ...module,
    // Ensure icon field is properly set for zeroConfiguration table
    icon: module.icon || null
  }))
);

// Methods
const setActiveTab = (tab: 'default' | 'lookup') => {
  activeTab.value = tab;
  tablePagination.value.current_page = 1;
  fetchModules(1, tablePagination.value.per_page);
};

const fetchModules = async (page = 1, limit = 10) => {
  isLoading.value = true;
  error.value = null;
  
  try {
    console.log(`Fetching ${activeTab.value} modules...`);
    const isDefault = activeTab.value === 'default';
    const response = await apiService.get('/common/workspace-modules-filter', { 
      is_default: isDefault,
      page,
      limit,
    });
    
    console.log('API Response:', response);
    
    if (Array.isArray(response.data)) {
      // Add module_type field for table display
      modules.value = response.data.map(module => ({
        ...module,
        module_type: activeTab.value === 'default' ? 'Default' : 'By Users'
      }));
      console.log(`Loaded ${modules.value.length} ${activeTab.value} modules`);
    } else {
      throw new Error('Invalid response format');
    }

    // backend gives pagination object
    if (response.pagination) {
      tablePagination.value.current_page = response.pagination.current_page || page;
      tablePagination.value.total_pages = response.pagination.total_pages || 1;
      tablePagination.value.total = response.pagination.total || modules.value.length;
      tablePagination.value.has_prev = (response.pagination.current_page || page) > 1;
      tablePagination.value.has_next =
        (response.pagination.current_page || page) < (response.pagination.total_pages || 1);
    } else {
      // Fallback if no pagination metadata
      tablePagination.value.current_page = page;
      tablePagination.value.total_pages = 1;
      tablePagination.value.total = modules.value.length;
      tablePagination.value.has_prev = false;
      tablePagination.value.has_next = false;
    }
  } catch (err: any) {
    console.error('Error fetching modules:', err);
    error.value = err?.response?.data?.message || err?.message || 'Failed to load modules';
    modules.value = [];
  } finally {
    isLoading.value = false;
  }
};

// Event handlers for zeroConfiguration table
const handleEdit = (module: any) => {
  // Only allow editing for default modules
  if (activeTab.value !== 'default') {
    console.log('Edit action not allowed for By Users modules');
    return;
  }
  
  if (!module._id) return;
  router.push({ 
    name: "create-workspace-module", 
    params: { moduleId: module._id } 
  });
};

const handleView = (module: any) => {
  // Only allow viewing for default modules
  if (activeTab.value !== 'default') {
    console.log('View action not allowed for By Users modules');
    return;
  }
  
  console.log('Viewing module:', module);
  alert(`Module: ${module.title}\nType: ${module.module_type}\nID: ${module._id}`);
};

const handleDelete = async (id: string) => {
  // Only allow deleting for default modules
  if (activeTab.value !== 'default') {
    console.log('Delete action not allowed for By Users modules');
    return;
  }
  
  if (!confirm("Are you sure you want to delete this module?")) return;
  
  try {
    console.log('Deleting module:', id);
    await apiService.delete('/common/workspace-modules', id);
    
    // Refresh the current tab data
    await fetchModules(tablePagination.value.current_page, tablePagination.value.per_page);
    
    // Show success message (you can replace with toast notification)
    console.log('Module deleted successfully');
  } catch (err: any) {
    console.error('Error deleting module:', err);
    alert('Failed to delete module: ' + (err?.message || 'Unknown error'));
  }
};

// Lifecycle
onMounted(() => {
  fetchModules(tablePagination.value.current_page, tablePagination.value.per_page);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", { active: activeTab.value === 'default' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('default'))),
            type: "button"
          }, " Default ", 2)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", { active: activeTab.value === 'lookup' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('lookup'))),
            type: "button"
          }, " By Users ", 2)
        ])
      ]),
      (activeTab.value === 'default' || (activeTab.value === 'lookup' && modules.value.length > 0))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/create-workspace-module'))),
            disabled: !_unref(canCreate)('main')
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fa fa-plus me-2" }, null, -1),
            _createTextVNode(" Create New ", -1)
          ]))], 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h5", _hoisted_9, _toDisplayString(currentTabTitle.value), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
              ], -1)),
              _createElementVNode("p", _hoisted_12, "Loading " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " modules...", 1)
            ]))
          : (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Error:", -1)),
                    _createTextVNode(" " + _toDisplayString(error.value), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-danger",
                    onClick: fetchModules
                  }, [...(_cache[10] || (_cache[10] = [
                    _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                    _createTextVNode(" Retry ", -1)
                  ]))])
                ])
              ]))
            : (modules.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(CommonTable2, {
                    tableObj: tableConfig.value,
                    title: '',
                    permissionKey: "main",
                    onEdit: handleEdit,
                    onDelete: handleDelete,
                    onView: handleView
                  }, null, 8, ["tableObj"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mb-3" }, [
                    _createElementVNode("i", { class: "fa fa-puzzle-piece fa-3x text-muted" })
                  ], -1)),
                  _createElementVNode("h5", _hoisted_18, "No " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " Modules Found", 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(activeTab.value === 'default' 
              ? 'No default modules are available.' 
              : 'No By Users modules are available.'), 1),
                  _createElementVNode("div", _hoisted_20, [
                    (activeTab.value === 'default')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-primary me-2",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/create-workspace-module'))),
                          disabled: !_unref(canCreate)('main')
                        }, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                          _createTextVNode(" Create Module ", -1)
                        ]))], 8, _hoisted_21))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-outline-secondary",
                      onClick: fetchModules
                    }, [...(_cache[13] || (_cache[13] = [
                      _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                      _createTextVNode(" Refresh ", -1)
                    ]))])
                  ])
                ]))
      ]),
      (modules.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("small", _hoisted_24, " Showing " + _toDisplayString(modules.value.length) + " " + _toDisplayString(activeTab.value === 'default' ? 'default' : 'By Users') + " module" + _toDisplayString(modules.value.length !== 1 ? 's' : ''), 1),
              _createElementVNode("button", {
                class: "btn btn-sm btn-outline-secondary",
                onClick: fetchModules
              }, [...(_cache[15] || (_cache[15] = [
                _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                _createTextVNode(" Refresh ", -1)
              ]))])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (modules.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm rows-select",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tablePagination.value.per_page) = $event)),
              onChange: changeRows
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                return _createElementVNode("option", {
                  key: n,
                  value: n
                }, _toDisplayString(n), 9, _hoisted_27)
              }), 64))
            ], 544), [
              [_vModelSelect, tablePagination.value.per_page]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "page-btn prev_btn",
              disabled: !tablePagination.value.has_prev,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
            }, " « ", 8, _hoisted_29),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
              return (_openBlock(), _createElementBlock("button", {
                key: index,
                class: _normalizeClass(["page-btn", {
            'page-active': p === tablePagination.value.current_page,
            'disabled-dots': p === '...',
          }]),
                disabled: p === '...',
                onClick: ($event: any) => (p !== '...' && typeof p === 'number' && handlePageChange(p))
              }, _toDisplayString(p), 11, _hoisted_30))
            }), 128)),
            _createElementVNode("button", {
              class: "page-btn next_btn",
              disabled: !tablePagination.value.has_next,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
            }, " » ", 8, _hoisted_31)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})